import actionTypes from 'constants/actionTypes'


export default [
  actionTypes.AUTH.LOGIN,
  actionTypes.AUTH.SIGNUP,
  actionTypes.AUTH.LOGOUT,
  actionTypes.AUTH.FORGOT_PASSWORD,
  actionTypes.AUTH.RESET_PASSWORD
]
